import extractDetailedQuestionnaireData from '../../data_management/extractDetailedQuestionnaireData'

const QuestionnaireEditorController = function ($routeParams, $scope, initialDataInteractor, questionnaireInteractor) {
  const $ctrl = this;

  const questionTypeLabels = {
    'radio': 'Select One',
    'checkbox': 'Select One or More',
    'text': 'Text Response',
    'range': 'Slider'
  };

  initialDataInteractor.executeWithInitializedSession(function () {
    $ctrl.questionnaireId = $routeParams[ 'id' ];

    $scope.$evalAsync(function () {
      questionnaireInteractor.loadQuestionnaire($ctrl.questionnaireId, onLoad);
    });
  });

  $ctrl.getLabelForQuestionType = function (question) {
    return questionTypeLabels[ question.question_type ]
  };

  $ctrl.onQuestionCreation = function () {
    $scope.$evalAsync(function () {
      questionnaireInteractor.loadQuestionnaire($ctrl.questionnaireId, onLoad);
    });
  };

  $ctrl.questionCreationIsPossible = function () {
    return $ctrl.selectableSections.length > 0;
  };

  $ctrl.deleteQuestion = function (questionPosition) {
    let confirmed = window.confirm("Are you sure that you want to delete this question? You won't be able to recover it.");

    $ctrl.processingChanges = true;

    if (confirmed) {
      questionnaireInteractor.removeQuestionFromQuestionnaire($ctrl.questionnaireId, questionPosition, function () {
        $ctrl.processingChanges = false;
        $scope.$evalAsync(function () {
          questionnaireInteractor.loadQuestionnaire($ctrl.questionnaireId, onLoad);
        });
      }, function () {
        alert('Failed to delete the question');
        $ctrl.processingChanges = false;
      })
    }
  };

  $ctrl.setPosition = function (currentIndex, targetIndex) {
    $ctrl.processingChanges = true;

    questionnaireInteractor.repositionQuestion($ctrl.questionnaireId, currentIndex, targetIndex, function (newQuestionnaire) {
      $ctrl.questionnaire = newQuestionnaire;
      // console.log(newQuestionnaire);
      setSelectedPositions();
      loadSections();
      $ctrl.processingChanges = false;
      $scope.$digest();
    }, function () {
      alert('Failed to reposition question');
      $ctrl.processingChanges = false;
    });
  };

  $ctrl.setQuestionSection = function (questionIndex, optionName) {
      $ctrl.addQuestionToSection(questionIndex, optionName)
  };

  $ctrl.addQuestionToSection = function (questionIndex, sectionName) {
    $ctrl.processingChanges = true;
      questionnaireInteractor.addQuestionToSection($ctrl.questionnaireId, questionIndex, sectionName, onSectionsChanged, function () {
        window.alert('Oops! We failed to set this question\'s section');
        $ctrl.processingChanges = false;
      })
  };

  $ctrl.moveSectionUp = function (section) {
    $ctrl.processingChanges = true;

    questionnaireInteractor.moveSectionUp($ctrl.questionnaire.id, section, function (newQuestionnaire) {
      onSectionsChanged(newQuestionnaire);
    }, function () {
      window.alert('Oops! We failed to reposition the section');
      $ctrl.processingChanges = false;
    })
  };

  $ctrl.moveSectionDown = function (section) {
    $ctrl.processingChanges = true;

    questionnaireInteractor.moveSectionDown($ctrl.questionnaire.id, section, function (newQuestionnaire) {
      onSectionsChanged(newQuestionnaire);
    }, function () {
      window.alert('Oops! We failed to reposition the section');
      $ctrl.processingChanges = false;
    })
  };

  $ctrl.getSectionByTitle = function (title) {
    return $ctrl.questionnaire.sections.find(section => {
      return section.title === title
    });
  };

  $ctrl.reloadSections = function () {
    onLoad();
  };

  $ctrl.getEmptySections = function () {
    let emptySections = questionnaireInteractor
      .getQuestionlessSections($ctrl.questionnaire)
      .map(section => section.title);

    return $ctrl.questionnaire.sections.filter(section => {
      return emptySections.find(emptySection => {
        return emptySection === section.title
      })
    })
  };

  $ctrl.createEmptySection = function () {
    let title = window.prompt('Enter a title for your new section.');

    if (title) {
      $ctrl.processingChanges = true;
      questionnaireInteractor.createEmptySection($ctrl.questionnaire.id, title, function () {
        $ctrl.processingChanges = false;
        onLoad();
      }, function () {
        window.alert('Oops! We failed to create your new section.');
        $ctrl.processingChanges = false;
      })
    }
  };

  $ctrl.deleteSection = function (sectionTitle) {
    let confirmed = window.confirm('Are you sure that you want to delete this section? The description will be lost');
    $ctrl.processingChanges = true;

    if (confirmed) {
      questionnaireInteractor.deleteSection($ctrl.questionnaireId, sectionTitle, function () {
        $ctrl.processingChanges = false;
        onLoad();
      }, function () {
        window.alert('Oops! We failed to delete your section');
        $ctrl.processingChanges = false;
      })
    }
  };

  function onSectionsChanged(newQuestionnaire) {
    $ctrl.questionnaire = newQuestionnaire;
    loadSections();
    setSelectedPositions();
    $ctrl.processingChanges = false;
    $scope.$digest();
  }

  function onLoad() {
    $ctrl.questionnaire = angular.copy(extractDetailedQuestionnaireData(initialDataInteractor, $ctrl.questionnaireId));
    // console.log("Questionnaire", $ctrl.questionnaire);
    loadSections();
    setSelectedPositions();
    $ctrl.isLoaded = true;
    $scope.$digest();
  }

  function setSelectedPositions() {
    $ctrl.positions = [];
    $ctrl.questionnaire.questions.forEach((question, index) => {
      let position = index + 1;
      $ctrl.positions.push(position);
      question.selectedPosition = position;
    });
  }

  function loadSections() {
    $ctrl.selectableSections = $ctrl.questionnaire.sections.map(section => section.title);
  }
};

export default {
  name: 'QuestionnaireEditorController',
  fn: QuestionnaireEditorController
};